export default __webpack_public_path__ + "5c99497c90c9e267b306aeaa203fd600.svg";